module.exports = __webpack_public_path__ + "img/calendar-date.3fe20ded.svg";